var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationMemoryInactive = function SvgTranslationMemoryInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M8.786 6C5.59 6 3 8.61 3 11.83a5.83 5.83 0 0 0 3.857 5.5v3.28c0 .347.416.52.659.275l3.198-3.223h4.5c3.196 0 5.786-2.61 5.786-5.831C21 8.61 18.41 6 15.214 6H8.786Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    x: 3,
    y: 4,
    fill: "#D6E5F2",
    rx: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.946 11.39a3.056 3.056 0 0 1-.028-.39c0-.132.012-.262.028-.39l-.87-.662a.196.196 0 0 1-.048-.256l.822-1.386c.051-.086.158-.122.25-.086l1.024.402a3.14 3.14 0 0 1 .695-.394l.154-1.06A.21.21 0 0 1 11.18 7h1.644c.103 0 .187.074.204.168l.154 1.06c.25.102.483.234.695.394l1.023-.402c.093-.034.2 0 .251.086l.822 1.386a.197.197 0 0 1-.049.256l-.867.662c.016.128.028.258.028.39s-.012.262-.028.39l.867.662c.078.06.1.168.05.256l-.823 1.386a.206.206 0 0 1-.25.086l-1.024-.402a3.14 3.14 0 0 1-.695.394l-.154 1.06a.206.206 0 0 1-.204.168H11.18a.206.206 0 0 1-.204-.168l-.154-1.06a3.065 3.065 0 0 1-.695-.394l-1.023.402c-.093.034-.2 0-.251-.086l-.822-1.386a.197.197 0 0 1 .049-.256l.867-.662Zm3.055 1.01c.796 0 1.439-.626 1.439-1.4 0-.774-.643-1.4-1.439-1.4-.795 0-1.439.626-1.439 1.4 0 .774.644 1.4 1.439 1.4Z"
  })));
};
export default SvgTranslationMemoryInactive;